import { firestore, firebase } from '../utilities/firebase'
import errorTypes from '../enums/errorTypes'
import { errorOfType } from '../utilities/Errors'
import addUidToObject from '../utilities/addUidToObject'
import removeUndefined from '../utilities/Data/removeUndefined'
import maybe from '../utilities/maybe'

const addItemVersion = async ({ itemDraft }) => {
	try {
		const itemVersion = addUidToObject(removeUndefined(itemDraft))
		if (itemVersion.uid && itemVersion.item) {
			let itemKey = itemVersion.itemKey
			const isCreate = !itemKey
			const itemsDocRef = isCreate ? firestore.collection('items').doc() : firestore.collection('items').doc(itemKey)
			itemKey = itemsDocRef.id

			// always add a version
			await itemsDocRef.collection('versions').add({
				...itemVersion,
				itemKey,
				createdTimestamp: firebase.firestore.FieldValue.serverTimestamp(),
				modifiedTimestamp: firebase.firestore.FieldValue.serverTimestamp()
			})

			// TODO: entity: move this to the backend - would need to keep track of the creator and all other editors
			// if there was already a version, update the sub collection
			await firestore.collection('userProfiles').doc(itemVersion.uid).collection('itemsEdited').doc(itemKey)
				.set({
					uid: itemVersion.uid,
					itemKey,
					...maybe({ createdTimestamp: firebase.firestore.FieldValue.serverTimestamp() }, isCreate),
					modifiedTimestamp: firebase.firestore.FieldValue.serverTimestamp()
				}, { merge: true })

			return { success: true, itemVersion, itemKey }
		}
		return { success: false, itemVersion }
	} catch (exception) {
		throw errorOfType(errorTypes.UNKNOWNERROR, { itemDraft }, exception)
	}
}

export default addItemVersion



// WEBPACK FOOTER //
// ./src/dataservices/addItemVersion.js